import React from "react";
import { CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

const UpgradeCardHeader = ({ newPlan, isTrial }) => (
  <CardHeader className="text-center">
    <CardTitle className="text-[22px] xs:text-2xl md:text-3xl font-bold">
      {isTrial ? "Start Your Free Trial" : "Confirm Plan Upgrade"}
    </CardTitle>
    <CardDescription className="text-sm md:text-base text-muted-foreground pt-1">
      {isTrial ? (
        <>
          Try <span className="font-semibold text-primary">{newPlan.name}</span>{" "}
          free for 30 days — no credit card required.
        </>
      ) : (
        <>
          You are about to upgrade your plan to{" "}
          <span className="font-semibold text-primary">{newPlan.name}</span>.
        </>
      )}
    </CardDescription>
  </CardHeader>
);

export default React.memo(UpgradeCardHeader);
